import { jsxs, jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import basket2xGraphic from '../assets/Basket2x.png.js';

const BasketImage = styled.img`
  margin: auto;
`;
const PAGE_NOT_FOUND_TEST_ID = '@web/PageNotFound';
/**
 * General Page Not Found component to be rendered on 404 pages
 */

const PageNotFound = () => jsxs("div", Object.assign({
  className: "h-margin-a-jumbo h-text-center h-text-grayDark",
  "data-test": PAGE_NOT_FOUND_TEST_ID
}, {
  children: [jsx("p", {
    children: `We're sorry! This page is currently unavailable. Please try again later.`
  }, void 0), jsx("div", Object.assign({
    className: "h-text-center h-margin-a-jumbo"
  }, {
    children: jsx(BasketImage, {
      alt: "Page Not Found basket",
      src: basket2xGraphic
    }, void 0)
  }), void 0)]
}), void 0);
PageNotFound.displayName = 'PageNotFound';

export { PAGE_NOT_FOUND_TEST_ID, PageNotFound };
